<button mat-button class="ribbon-button-padding" type="button" (click)="onClick()">
    <mat-icon class="save-icon" [class]="theme.myDialogIconBgColor">save</mat-icon> 
    <span>Save</span> 
</button>
